import script from "./MainContest.vue?vue&type=script&setup=true&lang=js"
export * from "./MainContest.vue?vue&type=script&setup=true&lang=js"

import "./MainContest.vue?vue&type=style&index=0&id=73a31800&lang=scss"

const __exports__ = script;

export default __exports__